import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
	server: {
		DB_IP_API_KEY: z.string(),

		OPENAI_API_KEY: z.string(),

		NFD_CRYPTO_SECRET: z.string(),

		STRIPE_WEBHOOK_SECRET_KEY: z.string(),

		STRIPE_SECRET_KEY: z.string(),

		APP_URL: z.string().url(),

		FIREBASE_SERVICE_ACCOUNT_CLIENT_EMAIL: z.string(),
		FIREBASE_SERVICE_ACCOUNT_PRIVATE_KEY: z.string(),
	},

	client: {
		NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_ID: z.string().optional(),

		NEXT_PUBLIC_FIREBASE_APP_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_PROJECT_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_API_KEY: z.string(),
		NEXT_PUBLIC_FIREBASE_DATABASE_URL: z.string(),

		NEXT_PUBLIC_CRYPTO_APP_SECRET_KEY: z.string(),
	},

	runtimeEnv: {
		NEXT_PUBLIC_CRYPTO_APP_SECRET_KEY:
			process.env.NEXT_PUBLIC_CRYPTO_APP_SECRET_KEY,

		DB_IP_API_KEY: process.env.DB_IP_API_KEY,

		OPENAI_API_KEY: process.env.OPENAI_API_KEY,

		NFD_CRYPTO_SECRET: process.env.NFD_CRYPTO_SECRET,

		STRIPE_WEBHOOK_SECRET_KEY: process.env.STRIPE_WEBHOOK_SECRET_KEY,

		STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,

		NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_ID:
			process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_ID,

		NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
			process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
		NEXT_PUBLIC_FIREBASE_PROJECT_ID:
			process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
		NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
		NEXT_PUBLIC_FIREBASE_DATABASE_URL:
			process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,

		FIREBASE_SERVICE_ACCOUNT_CLIENT_EMAIL:
			process.env.FIREBASE_SERVICE_ACCOUNT_CLIENT_EMAIL,
		FIREBASE_SERVICE_ACCOUNT_PRIVATE_KEY:
			process.env.FIREBASE_SERVICE_ACCOUNT_PRIVATE_KEY,

		APP_URL: process.env.APP_URL,
	},
});
